"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resize = void 0;
const web_env_1 = require("@snapchat/web-env");
const webp_1 = require("./webp");
const APS_SNAPS_SHARING_BASE_URL = "https://cf-st.sc-cdn.net/aps/snap_sharing/";
const APS_BOLT_BASE_URL = "https://cf-st.sc-cdn.net/aps/bolt_web/";
const APP_DOT_SNAPCHAT = "app.snapchat.com";
const FEELINSONICE = "feelinsonice-hrd";
const CF_ST = "cf-st.sc-cdn";
const BOLT_CDN = "bolt-gcdn.sc-cdn";
function resize({ imageUrl, width, height, preserveTransparency = false, applyDPR = true, format = undefined, }) {
    let pixelRatio = 1;
    if (applyDPR && !(0, web_env_1.isRunningOnServer)()) {
        // window should exist as we checked isRunningOnServer
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pixelRatio = (0, web_env_1.getWindow)().devicePixelRatio;
    }
    let formatString;
    if (typeof format !== "undefined") {
        formatString = `_FM${format}`;
    }
    else {
        formatString = (0, webp_1.isWebPSupported)() ? "_FMwebp" : preserveTransparency ? "_FMpng" : "";
    }
    if (imageUrl.includes(APP_DOT_SNAPCHAT) || imageUrl.includes(FEELINSONICE)) {
        return transform(width, height, pixelRatio, formatString, preserveTransparency, imageUrl, APS_SNAPS_SHARING_BASE_URL);
    }
    else if (imageUrl.includes(CF_ST) || imageUrl.includes(BOLT_CDN)) {
        return transform(width, height, pixelRatio, formatString, preserveTransparency, imageUrl, APS_BOLT_BASE_URL);
    }
    else {
        return imageUrl;
    }
}
exports.resize = resize;
function transform(width, height, pixelRatio, formatString, preserveTransparency, originalUrl, newBaseUrl) {
    const newWidth = Math.round(pixelRatio * width);
    const newHeight = Math.round(pixelRatio * height);
    const size = `_RS${newWidth},${newHeight}`;
    return `${newBaseUrl}${encodeUrl(originalUrl)}.${size}${formatString}`;
}
function encodeUrl(url) {
    return btoa(url).replaceAll("=", "");
}
//# sourceMappingURL=aps.js.map